import getters from '@/store/getters'
import Vue from 'vue'
import Vuex from 'vuex'

// actions
import actions from '@/store/actions'

// mutations
import modules from '@/store/modules'
import mutations from '@/store/mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    slide: {},
    slides: [],
    idSlide: null,
    audienceId: null,
    audienceName: '',
    audienceEmoji: '',
    audienceQuizTeam: null,
    slideOptions: [],
    isAudienceEmojiDisabled: false,
    quizStatus: 1,
    countdownTimeToAnswer: 0,
    logo: null,
    presentation: {},
    showQaSession: false,
    questions: [],
    tabQnaQuestion: 1,
    questionerName: '',
    questionCount: 0,
    socketDisconnect: false,
    connectionError: false,
    disableScrollBody: false,
    audienceEmail: '',
    audienceTeam: '',
    isAnswerSubmitted: false,
    showRequestPresentation: false,
    voiceCall: {}, // opentok video call
    authenticationCode: '',
    currentDataNextSlide: null, // handle correct next slide
    activeTabView: 'slide', // ['slide', 'feedback']
  },
  mutations,
  actions,
  modules,
  getters,
})
